import * as React from "react";
import Wait from "../../wait";
import ReadService from "../../../service/read";
import PopDetail from "../../popdetail";
import CreateService from "../../../service/create";
import {ProjectsService} from "../../../service/v1/projects";


export default class ParcelInfo extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            stage: 1,
            data: [],
        }
        this.loadData = this.loadData.bind(this)
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        try {
            Wait.show("Fetching Parcel Info....")
            ProjectsService.fetchParcelInfo(this.props.parcel.id).then(r => {
                Wait.dismiss()
                try {
                    console.log(r.data.results)
                    this.setState({
                        data: r.data.results
                    })
                } catch (e) {
                    console.log(e)
                }
            })
        } catch (e) {
            Wait.dismiss();
            console.log(e)
        }
    }


    render() {
        const fontFamily = 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif';
        const card = {
            background: '#fff',
            borderRadius: 10,
            boxShadow: '0 4px 12px rgba(57,93,154,0.10)',
            padding: '24px',
            margin: '24px auto',
            border: '1px solid #e0e7ef',
            maxWidth: 900,
            fontFamily
        };
        const cardHeader = {
            fontSize: 18,
            fontWeight: 700,
            color: '#395d9a',
            marginBottom: 18,
            display: 'flex',
            alignItems: 'center',
            gap: 10
        };
        const label = {
            fontWeight: 600,
            color: '#395d9a',
            fontSize: 14,
            marginBottom: 4
        };
        const input = {
            width: '100%',
            padding: '8px 12px',
            border: '1px solid #e0e7ef',
            borderRadius: 0,
            fontSize: 14,
            background: '#f8f9fa',
            color: '#333',
            marginBottom: 8
        };
        const sectionGrid = {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
            gap: 16,
            marginBottom: 24
        };
        const caption = {
            fontSize: 16,
            fontWeight: 700,
            color: '#fff',
            background: 'linear-gradient(90deg, #395d9a 0%, #2bbbad 100%)',
            padding: '8px 16px',
            borderRadius: 6,
            marginBottom: 16,
            display: 'inline-block',
            boxShadow: '0 2px 8px rgba(57,93,154,0.07)'
        };
        const paraComment = {
            fontSize: 15,
            color: '#333',
            marginBottom: 24,
            background: '#f8f9fa',
            borderLeft: '4px solid #2bbbad',
            padding: '10px 16px',
            borderRadius: 6
        };
        const sectionDivider = {
            height: '1px',
            background: 'linear-gradient(90deg, transparent 0%, #e0e7ef 50%, transparent 100%)',
            margin: '32px 0',
            border: 'none'
        };
        const outer = {
            width: '100%',
            minHeight: '40vh',
            maxHeight: '60vh',
            padding: '0 0 24px 0',
            background: '#f6f8fa',
            overflowY: 'auto',
            fontFamily
        };
        const getVal = (v) => v === undefined ? '' : v;
        const d = this.state.data;
        return (
            <div style={outer}>
                <div style={card}>
                    {d.paras_comment && (
                        <>
                            <div style={caption}>Para-surveyor Comment</div>
                            <div style={paraComment}>{d.paras_comment}</div>
                        </>
                    )}
                    
                    <div style={caption}>Reference Details</div>
                    <div style={sectionGrid}>
                        <div>
                            <div style={label}>Claim No.</div>
                            <input type='text' readOnly value={getVal(d.claim_no)} style={input}/>
                        </div>
                        <div>
                            <div style={label}>Claim Date</div>
                            <input type='text' readOnly value={getVal(d.claim_date)} style={input}/>
                        </div>
                        <div>
                            <div style={label}>UKA No.</div>
                            <input type='text' readOnly value={getVal(d.uka_namba)} style={input}/>
                        </div>
                        <div>
                            <div style={label}>Registration No.</div>
                            <input type='text' readOnly value={getVal(d.registration_no)} style={input}/>
                        </div>
                    </div>
                    
                    <hr style={sectionDivider} />
                    
                    <div style={caption}>Parcel Details</div>
                    <div style={sectionGrid}>
                        <div>
                            <div style={label}>Village</div>
                            <input type='text' readOnly value={getVal(d.locality)} style={input}/>
                        </div>
                        <div>
                            <div style={label}>Hamlet</div>
                            <input type='text' readOnly value={getVal(d.hamlet)} style={input}/>
                        </div>
                        <div>
                            <div style={label}>Parcel Land Use</div>
                            <input type='text' readOnly value={getVal(d.use)} style={input}/>
                        </div>
                        <div>
                            <div style={label}>Topology</div>
                            <input type='text' readOnly value={getVal(d.topology)} style={input}/>
                        </div>
                        <div>
                            <div style={label}>Status</div>
                            <input type='text' readOnly value={getVal(d.status)} style={input}/>
                        </div>
                        <div>
                            <div style={label}>Occupancy Type</div>
                            <input type='text' readOnly value={getVal(d.occupancy_type)} style={input}/>
                        </div>
                    </div>
                    
                    <hr style={sectionDivider} />
                    
                    <div style={caption}>Deed Plan Details</div>
                    <div style={sectionGrid}>
                        <div>
                            <div style={label}>Deed Plan Name</div>
                            <input type='text' readOnly value={getVal(d.deed_plan && d.deed_plan.name)} style={input}/>
                        </div>
                        <div>
                            <div style={label}>SRID</div>
                            <input type='text' readOnly value={getVal(d.deed_plan && d.deed_plan.srid)} style={input}/>
                        </div>
                        <div style={{gridColumn: '1 / span 2'}}>
                            <div style={label}>Deed Plan Description</div>
                            <input type='text' readOnly value={getVal(d.deed_plan && d.deed_plan.description)} style={input}/>
                        </div>
                    </div>
                    
                    <hr style={sectionDivider} />
                    
                    <div style={caption}>Neighbours</div>
                    <div style={sectionGrid}>
                        <div>
                            <div style={label}>North</div>
                            <input type='text' readOnly value={getVal(d.north)} style={input}/>
                        </div>
                        <div>
                            <div style={label}>South</div>
                            <input type='text' readOnly value={getVal(d.south)} style={input}/>
                        </div>
                        <div>
                            <div style={label}>East</div>
                            <input type='text' readOnly value={getVal(d.east)} style={input}/>
                        </div>
                        <div>
                            <div style={label}>West</div>
                            <input type='text' readOnly value={getVal(d.west)} style={input}/>
                        </div>
                    </div>
                    
                    <hr style={sectionDivider} />
                    
                    <div style={caption}>Village Adjudication Committee (VAC)</div>
                    <div style={sectionGrid}>
                        <div>
                            <div style={label}>First VAC Member</div>
                            <input type='text' readOnly value={getVal(d.vac_1)} style={input}/>
                        </div>
                        <div>
                            <div style={label}>Second VAC Member</div>
                            <input type='text' readOnly value={getVal(d.vac_2)} style={input}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

